/**
 * SPDX-FileCopyrightText: (c) 2000 Liferay, Inc. https://liferay.com
 * SPDX-License-Identifier: LGPL-2.1-or-later OR LicenseRef-Liferay-DXP-EULA-2.0.0-2023-06
 */

import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";

class WebComponent extends HTMLElement {
  constructor() {
    super();
    this.root = null;
  }

  connectedCallback() {
    if (!this.root) {
      this.root = createRoot(this);
    }

    const properties = {
      vocabId: this.getAttribute("vocabId"),
      delta: this.getAttribute("delta"),
    };

    this.root.render(<App properties={properties} />);
  }

  disconnectedCallback() {
    if (this.root) {
      this.root.unmount();
      this.root = null;
    }
  }
}

const ELEMENT_ID = "dwtc-services-and-applications";

if (!customElements.get(ELEMENT_ID)) {
  customElements.define(ELEMENT_ID, WebComponent);
} else {
  console.warn(`${ELEMENT_ID} is already defined.`);
}
